
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MyordersTable from "./dashboardtable/MyordersTable";
import MyinsuranceTable from "./dashboardtable/MyinsuranceTable";
import MyLoungesTable from "./dashboardtable/MyloungesTable";
import MyHotelsTable from "./dashboardtable/MyhotelsTable";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Cookies from "js-cookie";
import ReactSelect from "react-select";
import { useTranslation } from "react-i18next";
import './dashboardtable/ordersTable.css';
import MyOmanVisaTable from "./dashboardtable/MyOmanVisaTable";
const { config } = require("../src/api/api");


function OrdersTracking() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
  const [activePage, setActivePage] = useState("visa");
  const [title,setTitle]=useState(null)
  // const [header,setHeader] = useState("oman-visa")
    // const { t } = useTranslation();
      const base_url = config.baseURL;
    

    const [AccessToken, setAccessToken] = useState(null);
    const [VendorKey, setVendorKey] = useState(null);
    const [Payload, setPayload] = useState(null);
    const [userData, setUserData] = useState(null);
    const [optionList, setOptionList] = useState([{
      id:1,
      name:'Visa'
    },{
      id:2,
      name:'Oman-Visa'
    },
    {
      id:3,
      name:'Insurance'
    },
    {
      id:4,
      name:'Lounges'
    },
    {
      id:5,
      name:'Hotels'
    }
  ]);
  const [titleId,setTitleId]=useState(1);
    
const [loading, setLoading] = useState(false);

    useEffect(() => {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }, []);
  useEffect(() => {
    debugger
    const postvData = { organization_name: "Superjet" };
    if (VendorKey === "" || VendorKey === null || VendorKey === undefined) {
      fetch(base_url + "/create_organization", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postvData),
      })
        .then((response) => response.json())
        .then((data) => {
          setVendorKey(data.result[0].vendor_key);
        })
        .catch((error) => {
          console.error("Error Getting Vendor Key:", error);
        });
    }
  }, [VendorKey]); // Dependency array

  //  useEffect(() => {
  //     debugger;
  //     const storedUserString = Cookies.get("userData"); //sessionStorage.getItem('userData')
  //     if (storedUserString !== "undefined") {
  //       const storedUser = JSON.parse(storedUserString);
  //       setUserData(storedUser);
  //       setAccessToken(storedUser.access_token);
  //     }
  //   }, []);
  useEffect(() => {
  const storedUserString = Cookies.get("userData");

  if (storedUserString && storedUserString !== "undefined" && storedUserString !== "null") {
    try {
      const storedUser = JSON.parse(storedUserString);
      setUserData(storedUser);
      setAccessToken(storedUser.access_token);
    } catch (err) {
      console.error("Invalid JSON in userData cookie:", storedUserString);
      Cookies.remove("userData");
      navigate("/login"); // redirect if cookie is corrupted
    }
  } else {
    // No valid cookie, redirect to login
    navigate("/login");
  }
}, [navigate]);

  
  


    const handleInputChange =(e)=>{
      const {value,name,option_id}=e.target
      debugger
      const selectedOption = optionList.find(option => option.id === option_id);
      if (selectedOption) {
        setActivePage(selectedOption.name.toLowerCase());
        setTitleId(selectedOption.id);
        setTitle(selectedOption.name.toLowerCase());

      }
    }
  const renderContent = () => {


if(AccessToken && VendorKey ){
    
    var payload=null;
    if(userData.agency_name){ 
     payload={ token: AccessToken , user_type: "agent" }
    }
    else if(userData.type=="staff" && userData.staff_first_name){
     payload={ token: AccessToken , user_type: "staff" }
    }
    else{
    payload={ token: AccessToken , user_type: "traveller" }
    }
    switch (activePage) {
      case "oman-visa":
        return <MyOmanVisaTable AccessToken={AccessToken} VendorKey={VendorKey} Payload={payload} />
      case "visa":
         return <MyordersTable AccessToken={AccessToken} VendorKey={VendorKey} Payload={payload} />;
      case "insurance":
        return <MyinsuranceTable AccessToken={AccessToken} VendorKey={VendorKey} Payload={payload} />;
      case "lounges":
        return <MyLoungesTable AccessToken={AccessToken} VendorKey={VendorKey} Payload={payload} />;
      case "hotels":
        return <MyHotelsTable AccessToken={AccessToken} VendorKey={VendorKey} Payload={payload} />;
      default:
        // return <MyordersTable AccessToken={AccessToken} VendorKey={VendorKey} Payload={payload} />;
    }
}
  };

  const getButtonClass = (page) =>
    `btn btn-link w-100   text-decoration-none ${
      activePage === page ? "btn btn-primary text-light" : "text-dark"
    }`;
    // const getHeader =()=>{ if (activePage==="orders"){ 
    //   return
    // }}
   
    const titleCard=()=>{
      if(activePage==="oman-visa"){
       {lnstr == "en"?setTitle("Oman-Visa"):setTitle("تأشيرة عمان")}
      }
      if(activePage === "visa"){
       {lnstr == "en"?setTitle("Visa"):setTitle("تأشيرة")}
      }
      if(activePage === "insurance"){
       {lnstr == "en"? setTitle("Insurance"):setTitle("تأمين")}
      }
      if(activePage === "lounges"){
       {lnstr == "en"? setTitle("Lounges"):setTitle("الصالات")}
      }
      if(activePage === "hotels"){
        {lnstr == "en"? setTitle("Hotels"):setTitle("فنادق")}
      }
    }
 useEffect(()=>{
    titleCard();
 },[activePage,lnstr])




  return (

<>

     <div className="header_section1">
      <Navbar/>
        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">

            <h3 className="abt-txt my-5">{title}</h3>
          </div>
        </div>
      </div>

   
      {/* Sidebar */}

      <div className="">
     <div className="row  d-flex  " style={{overflow:'hidden',width:"100vw"}}>
   
   <div className="col-md-3 col-lg-2 side-dashboard-menu">
   <ul className="list-unstyled mb-0 p-0 w-100 h-100 "  style={{borderRight: "1px solid #b6b6b6",borderLeft:"1px solid #b6b6b6"}}>
      <li  style={{ flex: "1 1 0", /* grow, shrink, basis */
  textAlign: "center",
  // border: "1px solid #ccc",
 padding:"15px 0px",
 fontSize:"20px"
  }}>
         <b> {t("DashBoard")}</b>
          </li>
          <li  style={{ flex: "1 1 0", /* grow, shrink, basis */
  textAlign: "center",
  border: "1px solid #ccc",
  // borderTopLeftRadius:"5px",
  // borderBottomLeftRadius:"5px",
 backgroundColor:activePage==="visa"?"#3fd2f2":"",
 padding:"5px"
  }}>
            <button
              className={getButtonClass("visa")}
              style={{ fontSize: "18px",textAlign:"center",borderRadius:"0px" }}
              onClick={(e) => {e.preventDefault(); setActivePage("visa")}}
            >
              {t("Visa")}
            </button>
          </li>
           <li  style={{ flex: "1 1 0", /* grow, shrink, basis */
  textAlign: "center",
  border: "1px solid #ccc",
  // borderTopLeftRadius:"5px",
  // borderBottomLeftRadius:"5px",
 backgroundColor:activePage==="oman-visa"?"#3fd2f2":"",
 padding:"5px"
  }}>
            <button
              className={getButtonClass("oman-visa")}
              style={{ fontSize: "18px",textAlign:"center",borderRadius:"0px" }}
              onClick={(e) => {e.preventDefault(); setActivePage("oman-visa")}}
            >
              {t("Oman Visa")}
            </button>
          </li>
          <li   style={{ 
            // flex: "1 1 0", /* grow, shrink, basis */
  textAlign: "center",
  border: "1px solid #ccc",
  backgroundColor:activePage==="insurance"?"#3fd2f2":"",
  padding:"5px"
 }}>
            <button
              className={getButtonClass("insurance")}
              style={{ fontSize: "18px" ,textAlign:"center",borderRadius:"0px"}}
              onClick={(e) => {e.preventDefault();  setActivePage("insurance")}}
            >
              {t("Insurance")}
            </button>
          </li>
          <li   style={{ flex: "1 1 0", /* grow, shrink, basis */
  textAlign: "center",
  border: "1px solid #ccc",
  backgroundColor:activePage==="lounges"?"#3fd2f2":"",
  padding:"5px"
  }}>
            <button
              className={getButtonClass("lounges")}
              style={{ fontSize: "18px",textAlign:"center",borderRadius:"0px" }}
              onClick={(e) => {e.preventDefault();  setActivePage("lounges")} } 
            >
              {t("Lounges")}
            </button>
          </li>
          <li  style={{ flex: "1 1 0",
  textAlign: "center",
  border: "1px solid #ccc",
  backgroundColor:activePage==="hotels"?"#3fd2f2":"",
  padding:'5px'
  }}>
            <button
              className={getButtonClass("hotels")}
              style={{ fontSize: "18px",textAlign:"center",borderRadius:"0px" }}
              onClick={(e) => {e.preventDefault(); setActivePage("hotels")}}
            >
              {t("Hotels")}
            </button>
          </li> 
        </ul>
   </div>

    <div className="col-12  search-dashboard-menu"> 
      <div className ="row justify-content-center " >
        
         <div className={`col-lg-4 col-sm-12 col-md-6 mb-3 mt-3 ${lnstr=="ar"?"mr-3":"ml-3"}`} >
           {/* <label className="form-label">{t("Select Orders")} <span style={{color: 'red'}}>*</span></label> */} <div className="d-flex w-100 justify-content-center"> 
            <ReactSelect
             options={ optionList?.map((option) => ({ value: option.id, label: lnstr=="en"? option.name:t(option.name), })) } value={ optionList ?.map((option) => ({ value: option.id, label: lnstr=="en"? option.name:t(option.name), })) .find((option) => option.value === titleId) } 
             onChange={(selectedOption) => { handleInputChange({ target: { name: "selectedOrders", value: selectedOption?.label || '', option_id: selectedOption?.value || '', }, }); }} placeholder={t("Select")} isSearchable required className="w-100" 
             // styles={{width:"100%"}}
              />
              </div>
               </div>
                </div> 
                </div>
        {/* <div className="col-md-7 pt-5">
          <div className="w-100 orders-table">    
     
        </div>

       
     
</div> */}
      {/* Content */}
      <div className=" flex-grow-1 ">{renderContent()}</div>
    </div>

    </div>
    <div className="mt-3"></div>
    <Footer/>
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
}

export default OrdersTracking;
